import { OverlayRef } from '@angular/cdk/overlay';

export class NotesOverlayRef {
  constructor(private overlayRef: OverlayRef) {}

  close(): void {
    this.overlayRef.dispose();
  }
}
